import React, { useEffect } from "react";
import aboutImage from '../img/about.png';
import { Link } from "react-router-dom"; // ✅ import Link
import '../css/home.css';
import { FaArrowRight } from "react-icons/fa";

function About() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          }
        });
      },
      { threshold: 0.3 } // trigger when 30% of element is visible
    );

    const elements = document.querySelectorAll('.fade-up');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-section py-5">
      <div className="container">
        <div className="text-center mb-5 fade-up">
          <h6 className="section-tag">WHO WE ARE</h6>
          <hr className="center-hr " />
          <h2 className="section-title">About NeatNest</h2>
          <p className="section-desc">
            Delivering top-notch home cleaning services 
          </p>
        </div>

        <div className="row align-items-center">
          {/* Left Column - Image */}
          <div className="col-md-6 mb-4 mb-md-0 text-center fade-up">
            <img 
              src={aboutImage} 
              alt="About NeatNest" 
              className="img-fluid about-img"
            />
          </div>

          {/* Right Column - Text */}
          <div className="col-md-6 fade-up">
            <div className="about-text p-4 shadow-sm rounded">
              <p>
                NeatNest is a professional home cleaning service dedicated to providing 
                reliable, affordable, and high-quality cleaning solutions. 
                Our trained staff ensures your home stays clean, healthy, and hygienic. 
                We specialize in all types of cleaning services to make your home sparkling clean.
              </p>
              <p>
                With years of experience and a commitment to excellence, we make sure 
                every corner of your home is spotless. Trust NeatNest to give you 
                a safe, comfortable, and clean environment.
              </p>
              <Link to="/about" className="btn btn-primary mt-3 d-inline-flex align-items-center gap-2">
                Learn More
                 <FaArrowRight />
              </Link>
           
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
